@if (accountItem != undefined) {
	<div class="card shadow-sm my-3">
		<div class="card-header">
			<i class="far fa-user"></i>
			@if (contact == undefined) {
				<span
					><b> {{ customer.Name }} </b></span
				>
			}
			@if (contact != undefined) {
				<span
					><b> {{ contact.Name }} </b></span
				>
			}
		</div>
		<div class="card-body">
			@for (account of accountItem(); track account.Id) {
				<div class="acc-item p-3 d-flex align-items-center gap-5" [class.disabled]="account.DisabledOn !== undefined">
					<img [src]="getBankLogoByName(account.Bank)" class="bankLogo" />
					<div class="flex-fill">
						<div class="d-grid grid-4-col gap-2">
							<div>
								<sup class="text-muted">Holder Name</sup>
								<p class="fw-bold">{{ account.HolderName }}</p>
							</div>
							<div>
								<sup class="text-muted">Account Number</sup>
								<p class="fw-bold">{{ account.AccountNumber }}</p>
							</div>
							<div>
								<sup class="text-muted">Bank</sup>
								<p class="fw-bold">{{ account.Bank }}</p>
							</div>
							<div>
								<sup class="text-muted">Remark</sup>
								<p class="fw-bold">{{ account.Remark }}</p>
							</div>
						</div>
						@if (account.DisabledOn === undefined) {
							<div class="d-flex align-items-start justify-content-end">
								<div class="p-2 me-1" style="border: 2px dashed gray; border-radius: 15px">
									<div class="fw-bold">Account Actions</div>
									<div class="d-flex gap-1">
										@if (sharedService.isBranchAccountHandler()) {
											<button class="btn btn-dark" (click)="openAddBankAccountModal(account)" #tooltip="matTooltip" matTooltip="Duplicate Account" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
												<i class="far fa-clone"></i>
											</button>
										}
										<button class="btn btn-info" (click)="openAuthorizationHistoryModal(account)" #tooltip="matTooltip" matTooltip="Authorization History" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
											<i class="fas fa-history"></i>
										</button>
										@if (sharedService.isBranchAccountHandler()) {
											<button class="btn btn-warning" (click)="openUploadAcctDoc(account)" #tooltip="matTooltip" matTooltip="Upload Account Documents" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
												<i class="fas fa-upload"></i>
											</button>

											@if (contact == undefined) {
												<button class="btn btn-secondary" (click)="disableCustomerAccount(account)" #tooltip="matTooltip" matTooltip="Disable Account" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
													<i class="fas fa-ban"></i>
												</button>
											}
										}
									</div>
								</div>
								@if (sharedService.isBranchAccountHandler()) {
									<div class="p-2" style="border: 2px dashed gray; border-radius: 15px">
										<div class="fw-bold">Authorization Actions</div>
										<button class="btn btn-primary me-1" (click)="openAddAuthorizationModal(account)" #tooltip="matTooltip" matTooltip="Add Authorization Request" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
											<i class="far fa-paper-plane"></i>
										</button>
										<button class="btn btn-secondary me-1" (click)="openAuthorizationLetter(account)" #tooltip="matTooltip" matTooltip="Print Authorization Letter" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
											<i class="fas fa-print"></i>
										</button>

										<button class="btn btn-outline-info me-1" (click)="createSignLink(account)" #tooltip="matTooltip" matTooltip="Create Sign Link" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
											<i class="fas fa-link"></i>
										</button>
									</div>
								}
							</div>
						} @else {
							<div class="disable-remark fw-bold">
								<span class="badge text-danger-emphasis bg-danger-subtle border-danger-subtle text-uppercase fs-6">Disabled</span>
								Remark: {{ account.DisableRemark }}
							</div>
						}
					</div>
				</div>
			}
		</div>
	</div>
}

<ng-template #disableReason>
	<div class="mb-1">Disable Reason:</div>
	<textarea #reasonArea class="form-control" rows="5" required [value]="reason()" (keyup)="reason.set(reasonArea.value)" (blur)="reasonArea.reportValidity()" name="disableReason"></textarea>
</ng-template>
